<script setup lang="ts">
const props = defineProps<{
    digitNumber: '4' | '5';
}>()

const isDigit4 = computed(() => props.digitNumber === '4');
</script>

<template>
    <div class="gridClass section-py">
        <div class="flex flex-col lg:flex-row gap-10">
            <div class="w-full lg:w-1/2 flex flex-col justify-center gap-12">
                <div>
                    <h2 class="lg:text-start mb-4">تفاوت خط یک‌طرفه و دوطرفه</h2>
                    <p class="text-body2-semibold text-gray-500 text-center lg:text-justify">خطوط {{ props.digitNumber }} رقمی به‌صورت پیش‌فرض “یک‌طرفه” هستند. یعنی فقط امکان دریافت تماس دارند و نمی‌توانید با آن تماس خروجی بگیرید.</p>
                </div>
                <div>
                    <div class="flex justify-center lg:justify-start items-center gap-3 mb-4">
                        <Icon name="solar:refresh-circle-linear" class="text-secondary-600" size="25" />
                        <h3 class="text-gray-500">چگونه خط را دوطرفه کنیم؟</h3>
                    </div>
                    <p class="text-body2 text-center lg:text-start">برای فعال‌سازی تماس خروجی، کافی است {{ isDigit4 ? 'چهار' : 'سه' }} “صفر” به انتهای شماره اضافه شود تا خط به ۸ رقم تبدیل شده و قابلیت دوطرفه پیدا کند.</p>
                </div>
                <span class="text-gray-500 text-center lg:text-start text-body1-bold">تبدیل به حالت دوطرفه نیازمند درخواست جداگانه و تأیید مخابرات است.</span>
            </div>
            <div class="w-full lg:w-1/2 border-[3px] border-gray-200 p-4 rounded-2xl bg-gray-50 flex-center">
                <NuxtImg
                    :src="isDigit4 ? '/img/in-out-call-4-digit.webp' : '/img/in-out-call-5-digit.webp'"
                    alt="خطوط دوطرفه"
                    loading="lazy"
                />
            </div>
        </div>
    </div>
    <div class="gridClass section-py">
        <div class="flex flex-col lg:flex-row gap-10">
            <div class="w-full lg:w-1/2 border-[3px] border-gray-200 p-4 rounded-2xl bg-gray-50 flex-center order-2 lg:order-1">
                <NuxtImg
                    :src="isDigit4 ? '/img/require-docs-4-digit.webp' : '/img/require-docs-5-digit.webp'"
                    alt="مدارک مورد نیاز"
                    loading="lazy"
                />
            </div>
            <div class="w-full lg:w-1/2 flex flex-col justify-center gap-10 order-1 lg:order-2">
                <div>
                    <h2 class="lg:text-start mb-4">مدارک مورد نیاز برای ثبت خط {{ props.digitNumber }} رقمی</h2>
                    <span class="text-gray-500 text-center lg:text-justify text-body1-bold">
                        خطوط {{ props.digitNumber }} رقمی <span class="text-gray-600">فقط به اشخاص حقوقی (شرکت‌ها و سازمان‌ها)</span>  تعلق می‌گیرد.
                    </span>
                </div>
                <div class="flex flex-col gap-5">
                    <h3 class="text-gray-500">چک‌لیست مدارک:</h3>
                    <div class="flex items-center gap-3">
                        <Icon name="solar:check-circle-bold" class="text-secondary-600" size="24" />
                        <span class="w-[90%] text-body1-bold text-gray-500">تصویر پشت و رو از کارت ملی صاحبین امضای مجاز</span>
                    </div>
                    <div class="flex items-center gap-3">
                        <Icon name="solar:check-circle-bold" class="text-secondary-600" size="24" />
                        <span class="w-[90%] text-body1-bold text-gray-500">تصویر صفحه اول  (و صفحه تغییرات) شناسنامه  صاحبین امضای مجاز</span>
                    </div>
                    <div class="flex items-center gap-3">
                        <Icon name="solar:check-circle-bold" class="text-secondary-600" size="24" />
                        <span class="w-[90%] text-body1-bold text-gray-500">تصویر آگهی تاسیس شرکت</span>
                    </div>
                    <div class="flex items-center gap-3">
                        <Icon name="solar:check-circle-bold" class="text-secondary-600" size="24" />
                        <span class="w-[90%] text-body1-bold text-gray-500">تصویر روزنامه رسمی شرکت شامل آخرین تغییرات شرکت</span>
                    </div>
                    <div class="flex items-center gap-3">
                        <Icon name="solar:check-circle-bold" class="text-secondary-600" size="24" />
                        <span class="w-[90%] text-body1-bold text-gray-500">سند مالکیت یا اجاره نامه شرکت</span>
                    </div>
                </div>
                <div class="flex justify-center lg:justify-start gap-3">
                    <Icon name="solar:sort-by-time-linear" class="text-secondary-600" size="32" />
                    <span class="w-[90%] text-gray-500 text-body1-bold"><span class="text-gray-600">زمان تحویل:</span> نواتل فرآیند ثبت و پیگیری را به‌صورت کامل انجام می‌دهد و خط را در سریع‌ترین حالت ممکن به شما تحویل می‌دهد.</span>
                </div>
            </div>
        </div>
    </div>
</template>